<spe-termo-fidelidade
  *ngIf="showTermoFidelidade"
  class="termoFidelidade"
  [volumeContratado]="volumesContratados"
  [idPublicacao]="idPublicacaoTermoFidelidade"
>
</spe-termo-fidelidade>
<spe-termo-banner-aceitavel
  *ngIf="showPublicacaoAceitavelBanner"
  class="termoFidelidade"
  [idPublicacao]="idPublicacaoAceitavelBanner"
>
</spe-termo-banner-aceitavel>
<spe-termo-premmiar
  *ngIf="showTermoFidelidadePremmiar"
  class="termoFidelidade"
  [idPublicacao]="idPublicacaoTermoPremmiar"
>
</spe-termo-premmiar>

<div *ngIf="configuracoesOfertaImagem.length > 0">
  <spe-termo-generico *ngFor="let item of configuracoesOfertaImagem" [oferta]="item"></spe-termo-generico>
</div>

<spe-alert [class]="apiStatus" [message]="message"></spe-alert>

<!-- título e chips -->
<div class="row align-items-center mb-8">
  <div class="col-lg-6 d-flex align-items-center">
    <spe-titulo-sessao icone="assets/icones/cinza/avisos.svg" titulo="Notificações"></spe-titulo-sessao>

    <div *ngIf="isGrupo" class="ms-auto ms-lg-3 mt-4">
      <form [formGroup]="groupForm">
        <mat-chip-listbox [hideSingleSelectionIndicator]="true" formControlName="chips" class="d-block">
          <mat-chip-option selected (click)="toggleKeyword('Empresa', $event)"> {{ 'Empresa' }} </mat-chip-option>
          <mat-chip-option (click)="toggleKeyword('Grupo', $event)"> {{ 'Grupo' }} </mat-chip-option>
        </mat-chip-listbox>
      </form>
    </div>
  </div>

  <!-- select -->
  <div class="col-lg-4 offset-lg-2 text-end mt-lg-4 mt-2">
    <form [formGroup]="regiaoForm">
      <mat-form-field class="d-block d-lg-inline-block mb-0">
        <mat-label>Filtro de avisos</mat-label>
        <mat-select name="listRegions" formControlName="regiao">
          <mat-option *ngFor="let element of listRegions" [value]="element.idDistribuidor">{{
            element.nomeDistribuidor
          }}</mat-option>
        </mat-select>
        <mat-icon matSuffix class="color-brand-principal">keyboard_arrow_down</mat-icon>
      </mat-form-field>
    </form>
  </div>
</div>

<!-- tabela de notificacoes -->
<div class="overflow-x-auto rounded-16">
  <table mat-table spe-table [dataSource]="dataSource" matSort>
    <ng-container matColumnDef="data">
      <th mat-header-cell *matHeaderCellDef mat-sort-header width="180">Data</th>
      <td mat-cell *matCellDef="let element; dataSource: dataSource">{{ formataData(element.data) }}</td>
    </ng-container>

    <ng-container matColumnDef="titulo">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Assunto</th>
      <td mat-cell *matCellDef="let element; dataSource: dataSource">{{ element.titulo }}</td>
    </ng-container>

    <ng-container matColumnDef="icone">
      <th mat-header-cell *matHeaderCellDef></th>
      <td
        mat-cell
        *matCellDef="let element; dataSource: dataSource"
        (click)="getPublicacao(element.idPublicacao)"
        class="text-end"
      >
        <button mat-icon-button matTooltip="Visualizar" matTooltipPosition="above">
          <mat-icon svgIcon="olho-aberto-current" class="color-brand-principal"></mat-icon>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    <!-- Row para quando nao encontra resultado da busca -->
    <tr class="background" *matNoDataRow>
      <td class="pt-24 pb-24" colspan="8">Não há notificações com os critérios informados</td>
    </tr>
  </table>
</div>

<mat-paginator class="mt-3" showFirstLastButtons [length]="100" [pageSize]="10" [pageSizeOptions]="[10, 25, 50, 100]">
</mat-paginator>
